if (
  typeof Array !== undefined
  && Array.prototype
  && !Array.prototype.flat
) {
  Object.defineProperty(Array.prototype, 'flat', {
    value(depth = 1) {
      return this.reduce(function (flat, toFlatten) {
        return flat.concat(Array.isArray(toFlatten) && depth > 1 ? toFlatten.flat(depth - 1) : toFlatten);
      }, []);
    }
  });
}